<template>
  <form
    autocomplete="off"
    @submit.prevent="$emit('submit')"
  >
    <TextInput
      v-model.trim="model.sectionName"
      v-focus
      required
      :validation-error="error"
      label="Section Name"
    />
  </form>
</template>

<script setup>
import { TextInput } from '@/components/form-inputs';

defineEmits(['submit']);

defineProps({
  error: {
    type: String,
    default: null,
  },
});

const model = defineModel();
</script>
